var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","display":"flex","align-items":"center","justify-content":"center"}},[_c('apexchart',{ref:"chart",attrs:{"type":_vm.type,"width":_vm.width,"height":_vm.height,"options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }